<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  teams: { type: Array, default: () => [] },
});

const emit = defineEmits(['select']);

const { t } = useI18n();
</script>

<template>
  <div
    v-if="!teams.length"
    class="flex items-center justify-center py-16 rounded-xl outline outline-1 -outline-offset-1 outline-n-container bg-n-solid-2"
  >
    <span class="text-sm text-n-slate-11">
      {{ t('TEAM_PAGE.TEAMS.EMPTY') }}
    </span>
  </div>
  <div
    v-else
    class="overflow-hidden rounded-xl outline outline-1 -outline-offset-1 outline-n-container bg-n-solid-2"
  >
    <ul class="m-0 list-none divide-y divide-n-weak">
      <li v-for="team in teams" :key="team.id">
        <button
          type="button"
          class="flex items-center w-full gap-3 px-4 py-3.5 text-start transition-colors hover:bg-n-alpha-1"
          @click="emit('select', team.id)"
        >
          <span
            class="grid rounded-lg size-8 shrink-0 place-items-center bg-n-violet-3 text-n-violet-11"
          >
            <span class="i-lucide-users-round size-4" />
          </span>
          <span class="flex-1 min-w-0">
            <span class="block text-sm font-medium truncate text-n-slate-12">
              {{ team.name }}
            </span>
            <span class="block text-xs truncate text-n-slate-10">
              {{ team.description || t('TEAM_PAGE.TEAMS.NO_DESCRIPTION') }}
            </span>
          </span>
          <span class="text-xs shrink-0 text-n-slate-11">
            {{ t('TEAM_PAGE.TEAMS.MEMBERS', { count: team.memberCount }) }}
          </span>
          <span
            class="i-lucide-chevron-right size-4 shrink-0 text-n-slate-10"
          />
        </button>
      </li>
    </ul>
  </div>
</template>
